module.exports = __webpack_public_path__ + "51bea10553f286720ef3289432861d3f.svg";